document.addEventListener("DOMContentLoaded",()=>{

const cards = document.querySelectorAll(".hub-grid__card");

if(!cards.length) return;

cards.forEach(card=>{

card.style.opacity="0";
card.style.transform="translateY(30px)";
card.style.transition="all .6s ease";

});

const observer = new IntersectionObserver(entries=>{

entries.forEach(entry=>{

if(entry.isIntersecting){
entry.target.style.opacity="1";
entry.target.style.transform="translateY(0)";
}

});

},{threshold:.2});

cards.forEach(card=>observer.observe(card));

});